import "./style.scss";
import $ from "jquery";

$(document).ready(function () {

    $('.dinos-gallery').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        arrows: false,
        adaptiveHeight: true,
        // autoplay: true,
        // autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 989,
                settings: {
                    //dots: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    // dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    $('.dinos-gallery__column').magnificPopup({
        delegate: 'a',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
            tCounter: '<span class="mfp-counter">%curr% od %total%</span>'
        }
    });

    //star način
    // $('.dinos-gallery').slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     dots: true,
    //     arrows: false,
    //     adaptiveHeight: true,
    //     // autoplay: true,
    //     // autoplaySpeed: 2000,
    //     responsive: [
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 dots: false,
    //             }
    //         }
    //     ]
    // });
});